<template>
    <div class="bg-white center-block p-4 shadow-xl sm:p-12 sm:w-3/4 w-full font-serif index-wrapper">
        <div class="title">$<span class="red price">{{ costEstimate }}</span> estimated monthly expense</div>
        <!--<div class="row-item">
            <input type="checkbox" id="office365" v-model="office365.status" class="form-checkbox text-red-600">
            <label for="office365">Office 365</label>
        </div>
            <div v-if="office365.status" class="sub-section row-item">
            <input id="office365-users" type="number" v-model.number="office365.users">
            <label class="no-pad" for="office365-users">users</label>
        </div> -->
        <div class="row-item">
            <input type="checkbox" id="gateway" v-model="gateway.status" class="form-checkbox text-red-600">
            <label for="gateway">Email Gateway</label>
        </div>
        <div v-if="gateway.status" class="sub-section row-item">
            <input id="gateway-users" type="number" v-model.number="gateway.users">
            <label class="no-pad" for="gateway-users">users</label>
        </div>
        <input v-model="name" placeholder="Name">
        <input v-model="email" placeholder="Email">
        <input v-model="phone" placeholder="Phone">
        <input v-model="company" placeholder="Company Name (optional)">
        <textarea class="block w-full"  placeholder="Describe your desired setup" type="text" v-model="setup"></textarea>
        <button class="button-red">Submit Request</button>
    </div>
</template>

<script>
export default {
  name: "Form",
  data() {
      return {
          // office365: {
          //     status: false,
          //     users: 0
          // },
          gateway: {
              status: false,
              users: 0
          },
          name: null,
          email: null,
          phone: null,
          company: null,
          setup: null,
          costs: {
            // office365: 10,
            emailGateway: 5,
        }
      }
  },
  computed: {
    costEstimate: function() {
      // let { costs, office365, gateway } = this
      // let result = costs.office365 * office365.users + costs.emailGateway * gateway.users
      let { costs, gateway } = this
      let result = costs.emailGateway * gateway.users
      return result
    }
  }
};
</script>

<style>
.index-wrapper {
    font-size: 1.2rem;
}
.row-item {
  padding: 5px 0;
}
.red {
  color: #e53e3e;
}
.sub-section {
  padding-left: 20px;
}
.title {
    font-size: 1.4rem;
    padding-bottom: 10px
}
.price {
  font-size: 1.6rem;
}
.button-red {
  background: #e53e3e;
  color: #ffffff;
  font-size: 1rem;
  padding: 8px 12px;
  border-radius: 0.25rem;
  margin-top: 30px;
}

label {
  padding-left: 10px;
}
input[type="number"] {
  padding: 0;
  width: 80px;
  text-align: center;
}

input {
  width: 100%;
  border-bottom: 1px solid #dae1e7;
  margin: 10px 0;
}
input:focus {
  border-bottom: 1px solid #e53e3e;
}
textarea {
  padding: 10px;
  height: 200px;
  margin: 5px 0;
  border: 1px solid #dae1e7;
}


</style>
